import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppState } from '@app/reducers';
import { ANGULAR_EDITOR_CONFIG } from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, emailCCPattern, setRequiredValidator } from '@app/shared/utils';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { loggedInUserData } from '@modules/others';
import { LeadEmailNotificationtModel } from '@modules/sales/models/lead-email-notification.model';
import { Store } from '@ngrx/store';
import { SalesModuleApiSuffixModels } from '@sales/shared';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
@Component({
  selector: 'app-email-modal-component',
  templateUrl: './email-modal.component.html',
  styleUrls: ['./lead-notes.scss'],
})
export class EmailModalComponent implements OnInit {
  leadId: string;
  emailNotificationForm: FormGroup;
  loggedInUserData: LoggedInUserModel;
  fileList: File[] = [];
  customerId = "";
  config: AngularEditorConfig = ANGULAR_EDITOR_CONFIG;
  data;

  constructor(private formBuilder: FormBuilder, public ref: DynamicDialogRef,public configData: DynamicDialogConfig,private activatedRoute: ActivatedRoute,
    private rxjsService: RxjsService,
    private crudService: CrudService, private store: Store<AppState>) {
      this.data=configData?.data;
  }

  ngOnInit() {
    this.rxjsService.setDialogOpenProperty(true);
    this.combineLatestNgrxStoreData();
    this.createEmailNotificationAddForm();
  }

  combineLatestNgrxStoreData(): void {
    combineLatest([this.store.select(loggedInUserData), this.activatedRoute.queryParams]
    ).pipe(take(1)).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      this.leadId = response[1]?.leadId;
    });
  }

  createEmailNotificationAddForm(): void {
    let emailNotificationModel = new LeadEmailNotificationtModel();
    this.emailNotificationForm = this.formBuilder.group({});
    Object.keys(emailNotificationModel).forEach((key) => {
      if (key == 'notificationCC') {
        this.emailNotificationForm.addControl(key,
          new FormControl(emailNotificationModel[key], Validators.compose([emailCCPattern])));
      }
      else {
        this.emailNotificationForm.addControl(key, new FormControl(emailNotificationModel[key]));
      }
    });
    this.emailNotificationForm.get('notificationTo').setValue(this.data.email);
    this.emailNotificationForm = setRequiredValidator(this.emailNotificationForm, ["notificationTo", "notificationSubject", "notificationText"]);
  }

  emitUploadedFiles(uploadedFiles: any[]) {
    this.fileList = uploadedFiles;
  }

  onSubmit(): void {
    if (this.emailNotificationForm.invalid) {
      this.emailNotificationForm.markAllAsTouched();
      return;
    }
    var formValue = this.emailNotificationForm.value;
    formValue.leadId = this.data.leadId;
    formValue.createdUserId = this.loggedInUserData.userId;
    formValue.customerId = this.data.customerId;
    let formData = new FormData();
    formData.append('email', JSON.stringify(formValue));
    this.fileList.forEach(file => {
      formData.append('file', file);
    });
    this.crudService.create(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_LEAD_NOTIFICATIONS_EMAIL, formData)
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200) {
          this.rxjsService.setLeadNotesUpdateStatus(true);
          this.rxjsService.setDialogOpenProperty(false);
          this.ref.close(true);
        }
      });
  }

  dialogClose(): void {
    this.ref.close(false);
}

  ngOnDestroy() {
    this.rxjsService.setDialogOpenProperty(false);
  }
}
